export interface IDownloadCSV {
  data: string
  fileName: string
  fileType: string
}

export const ENV_ALLOWED_URLS = {
  production: ['console.outbound.ai', 'console.phoenix.outbound.ai'],
  staging: [
    'console.stg.outbound.ai',
    'pre-staging.virtualoutbound.com',
    'console.stg.outbound.ai',
    'dal-stg-console.phoenix.stg.outbound.ai',
    'integration-console.phoenix.stg.outbound.ai',
    'locutusphi-console.phoenix.stg.outbound.ai',
  ],
  development: [
    'console.virtualoutbound.com',
    'yogineen-console.phoenix.dev.virtualoutbound.com',
    'wesleyp-console.phoenix.dev.virtualoutbound.com',
    'claudea-console.phoenix.dev.virtualoutbound.com',
    'michaels-console.phoenix.dev.virtualoutbound.com',
    'dev01-console.phoenix.dev.virtualoutbound.com',
    'mitchr-console.phoenix.dev.virtualoutbound.com',
    'davidm-console.phoenix.dev.virtualoutbound.com ',
    'locutus-console.phoenix.dev.virtualoutbound.com',
    'nayans-console.phoenix.dev.virtualoutbound.com',
  ],
}
